import { DownloadIcon } from "@/Icons/v2/Download";
import type { LibraryFile } from "@/pages/library_v2/components/filesView/types";
import { downloadFile } from "@/pages/library_v2/components/filesView/utils";
import { useTrans } from "@/translations";

import type { Ref } from "react";

import { ActionButton } from "./actionButton";

type Props = {
  file: LibraryFile;
  tooltipPlacement: "bottom" | "top";
  downloadButtonRef: Ref<HTMLButtonElement>;
};

export const DownloadAction: React.FC<Props> = ({
  file,
  tooltipPlacement,
  downloadButtonRef,
}) => {
  const { t } = useTrans();

  return (
    <ActionButton
      icon={<DownloadIcon size={20} color="#1D1C1C" />}
      label={t("libraryPage:fileListActionDownload")}
      buttonRef={downloadButtonRef}
      placement={tooltipPlacement}
      onClick={() => downloadFile(file)}
    />
  );
};
